module.exports = __webpack_public_path__ + "img/bm2.jpeg";